import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import Moment from "moment";

import { ApiService } from "src/app/api.service";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { DayPickerComponent } from "src/app/shared/day-picker/day-picker.component";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-usage-report",
	templateUrl: "./usage-report.component.html",
	styleUrls: ["./usage-report.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterLink, FormsModule, DayPickerComponent, ActionButtonComponent]
})
export class UsageReportComponent {
	private fleettracker = inject(FleetTrackerService);
	private api = inject(ApiService);

	public brand = BrandVars;

	public fleet?: APIResults.Fleet;
	public assets: APIResults.SelectableFleetAsset[];

	public startDate: string;
	public endDate: string;

	public includeOperations = true;
	public includeExceedances = true;
	public includeUserAccess = true;

	constructor() {
		this.startDate = Moment().add(-1, "months").add(1, "days").format("YYYY-MM-DD");
		this.endDate = Moment().format("YYYY-MM-DD");
		this.fleettracker.currentFleet.pipe(takeUntilDestroyed()).subscribe(currentfleet => {
			this.fleet = currentfleet;
			if (this.fleet && this.fleet.assets && this.fleet.assets.length > 0) {
				this.assets = this.fleet.assets.slice().sort((a, b) => {
					if (a.organization_name > b.organization_name) { return 1; }
					if (a.organization_name < b.organization_name) { return -1; }
					if (a.asset_name > b.asset_name) { return 1; }
					if (a.asset_name < b.asset_name) { return -1; }
					return 0;
				}) as APIResults.SelectableFleetAsset[];
				this.assets.forEach(asset => {
					asset.selected = true;
				});
			} else {
				this.assets = null;
			}
		});
	}

	SelectAll() {
		for (const asset of this.assets) {
			asset.selected = true;
		}
	}

	SelectNone() {
		for (const asset of this.assets) {
			asset.selected = false;
		}
	}

	async GenerateReport() {
		const selectedAssets = this.assets.filter(asset => asset.selected);
		if (selectedAssets.length === 0) throw new Error("No assets selected");
		const endInclusive = Moment(this.endDate).add(1, "days").format("YYYY-MM-DD");
		await this.api.GenerateUsageReport(selectedAssets.map(asset => asset.asset_id), this.startDate, endInclusive);
	}
}
